<template>
  <div>
    <p class="mb-2 text-2xl font-bold text-center">Talk to Us</p>
    <p class="mb-2 text-base font-medium text-center text-gray-700">
      Fill out the form and we'll connect you with our team of experts shortly.
    </p>

    <form @submit.prevent="submitForm" method="POST">
      <div class="grid grid-cols- sm:grid-cols-2 gap-6 mt-6">
        <div>
          <label
            for="firstName"
            class="block text-sm font-medium leading-5 text-gray-700"
            >First Name</label
          >
          <div class="mt-1 rounded-md shadow-sm">
            <input
              id="firstName"
              type="text"
              name="firstName"
              v-model="form.firstName"
              placeholder="First name"
              required
              class="w-full"
              autofocus
            />
          </div>

          <div class="error" v-if="errors.firstName">
            {{ errors.firstName }}
          </div>
        </div>
        <div>
          <label
            for="lastName"
            class="block text-sm font-medium leading-5 text-gray-700"
            >Last Name</label
          >
          <div class="mt-1 rounded-md shadow-sm">
            <input
              id="lastName"
              type="text"
              name="lastName"
              v-model="form.lastName"
              placeholder="Last name"
              required
              class="w-full"
              autofocus
            />
          </div>

          <div class="error" v-if="errors.lastName">
            {{ errors.lastName }}
          </div>
        </div>
      </div>

      <div class="mt-6">
        <label
          for="businessEmail"
          class="block text-sm font-medium leading-5 text-gray-700"
        >
          Approximately how many verifications a month
        </label>
        <div class="mt-1 rounded-md shadow-sm">
          <multiselect
            v-model="form.verificationNumber"
            :options="listNumberVerifications"
            :searchable="false"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Pick a value"
          ></multiselect>
        </div>

        <div class="error" v-if="errors.verificationNumber">
          {{ errors.verificationNumber }}
        </div>
      </div>

      <div class="mt-6">
        <label
          for="message"
          class="block text-sm font-medium leading-5 text-gray-700"
        >
          Company
        </label>
        <div class="mt-1 rounded-md shadow-sm">
          <input
            id="companyName"
            type="text"
            name="companyName"
            v-model="form.companyName"
            placeholder="Company name"
            required
            class="w-full"
            rows="2"
          />
        </div>
        <div class="error" v-if="errors.companyName">
          {{ errors.companyName }}
        </div>
      </div>

      <div class="mt-6">
        <label
          for="jobTitle"
          class="block text-sm font-medium leading-5 text-gray-700"
        >
          Job Title
        </label>
        <div class="mt-1 rounded-md shadow-sm">
          <input
            id="jobTitle"
            type="text"
            name="jobTitle"
            placeholder="Job Title"
            v-model="form.jobTitle"
            class="w-full"
            rows="2"
            required
          />
        </div>
        <div class="error" v-if="errors.jobTitle">
          {{ errors.jobTitle }}
        </div>
      </div>

      <div class="mt-6">
        <label
          for="businessEmail"
          class="block text-sm font-medium leading-5 text-gray-700"
        >
          Business Email
        </label>
        <div class="mt-1 rounded-md shadow-sm">
          <input
            id="businessEmail"
            type="email"
            name="businessEmail"
            placeholder="Business email"
            v-model="form.businessEmail"
            required
            class="w-full"
            rows="2"
          />
        </div>

        <div class="error" v-if="errors.businessEmail">
          {{ errors.businessEmail }}
        </div>
      </div>

      <p class="mt-6 text-sm font-medium text-gray-700 text-left">
        By submitting this form, you confirm that you have read and understand
        our
        <a
          class="link"
          href="https://www.youverse.id/privacy-policy"
          target="_blank"
          >Privacy Policy</a
        >. Please send me updates about Youverse products and services, industry
        updates, and other useful information.
      </p>

      <div class="mt-6">
        <span class="block w-full rounded-md shadow-sm">
          <button type="submit" class="btn-primary w-full">Submit</button>
        </span>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    errors: Object,
  },

  data() {
    return {
      form: {
        firstName: null,
        lastName: null,
        companyName: null,
        businessEmail: null,
        jobTitle: null,
        verificationNumber: "<1 000",
      },
      listNumberVerifications: [
        "<1 000",
        "<10 000",
        "<100 000",
        "<500 000",
        ">1 000 000",
      ],
      showForm: true,
    };
  },
  methods: {
    submitForm() {
      this.$inertia.post("/talk-to-us", this.form, {
        preserveScroll: true,
        onSuccess: (e) => {
          if (e.props.flash.message != null) {
            this.$store.commit("showFlashMessage", {
              message: e.props.flash.message,
              type: e.props.flash.message_type,
            });
          }

          if (e.props.flash.message_type === "success") {
            dataLayer.push({ event: "submit_form_contact_us" });
            this.firstName = null;
            this.lastName = null;
            this.companyName = null;
            this.businessEmail = null;
            this.jobTitle = null;
            this.$emit("closeModalTalkToUs");
          }
        },
      });
    },
  },
};
</script>
